import { render, staticRenderFns } from "./pictureLibrary.vue?vue&type=template&id=2aa08769&scoped=true"
import script from "./pictureLibrary.vue?vue&type=script&lang=js"
export * from "./pictureLibrary.vue?vue&type=script&lang=js"
import style0 from "./pictureLibrary.vue?vue&type=style&index=0&id=2aa08769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa08769",
  null
  
)

export default component.exports